/** Relay projections of the full ledger, never a fold of the bounded fills list. */
export interface PolyMergeAccounting {
  kind: "merge";
  intent_id: string;
  ticker: string;
  condition_id: string;
  quantity_atomic: string;
  collateral_atomic: string;
  executed_at: string;
  yes_cost_cents: number | null;
  no_cost_cents: number | null;
  gross_pnl_cents: number | null;
  execution_fee_cents: null;
  accounting_status: "accounted" | "conflict";
}

export function decodePolyMerges(
  payload: unknown,
): PolyMergeAccounting[] | null {
  if (!payload || typeof payload !== "object") return null;
  const rows = (payload as { merges?: unknown }).merges;
  if (!Array.isArray(rows)) return null;
  const ids = new Set<string>();
  for (const row of rows) {
    if (
      !row ||
      typeof row !== "object" ||
      row.kind !== "merge" ||
      typeof row.intent_id !== "string" ||
      !row.intent_id ||
      ids.has(row.intent_id) ||
      typeof row.ticker !== "string" ||
      !row.ticker ||
      typeof row.condition_id !== "string" ||
      !row.condition_id ||
      typeof row.quantity_atomic !== "string" ||
      !/^[1-9]\d*$/.test(row.quantity_atomic) ||
      typeof row.collateral_atomic !== "string" ||
      !/^\d+$/.test(row.collateral_atomic) ||
      typeof row.executed_at !== "string" ||
      !Number.isFinite(Date.parse(row.executed_at)) ||
      !["accounted", "conflict"].includes(row.accounting_status) ||
      row.execution_fee_cents !== null ||
      ![row.yes_cost_cents, row.no_cost_cents, row.gross_pnl_cents].every(
        (v) => v === null || (typeof v === "number" && Number.isFinite(v)),
      )
    )
      return null;
    if (
      row.accounting_status === "accounted" &&
      [row.yes_cost_cents, row.no_cost_cents, row.gross_pnl_cents].some(
        (v) => v === null,
      )
    )
      return null;
    ids.add(row.intent_id);
  }
  return rows;
}

/** Preserve six-place token evidence without converting large atomic strings to floats. */
export function formatMergeAtomic(value: string): string {
  const padded = value.padStart(7, "0");
  const fraction = padded.slice(-6).replace(/0+$/, "");
  return `${padded.slice(0, -6)}${fraction ? `.${fraction}` : ""}`;
}
